import type { FaireProductEntity } from "../../entity_types/product";

export const p_wrudjxpkq2: FaireProductEntity = {
  token: "p_wrudjxpkq2",
  type: "product",
  name: "Hand-Carved Serpentine Leopard Gemstone Animal Figurine",
  brandToken: "b_yv36hmng6n",
  brandName: "Gem Avenue Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/5b55a232350232e61f241f643b95b14aa669fdaca458e8d5bb7b8c413f7a431a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed235a7be2bbbaecc047fcc3a949d739b2c843de306198408c98c0d0372bf36d.jpeg",
    "https://cdn.faire.com/fastly/8cc5e5db16acfd98f49b965cc3fc1b8754c8e0aa400b4644fe21bfec32fccdaf.jpeg",
    "https://cdn.faire.com/fastly/faf1536b94f45ae7b6c4575cbd561c2988d2ce52c866ff6753bb77b830ddc240.jpeg",
    "https://cdn.faire.com/fastly/bb1cf808f2a3e882c313d2cbf42d0b7fa6b4e0fbd2ac4996632bf5d01a12ebdf.jpeg",
    "https://cdn.faire.com/fastly/3561cef926710ac529cf3fd79a8f6d20c91fee6dc969603eb3e556d8f261c5ce.jpeg",
  ],
  priceDollars: 54.87,
  description:
    "Enhance your collection with our Hand-Carved Serpentine Leopard Gemstone Animal Figurine! Each piece is beautifully crafted and unique, adding a touch of exotic beauty to any interior. Hand-carved from high-quality serpentine gemstone, this figurine is a must-have for any wholesale buyer.\n",
  tags: [],
  msrpDollars: 109.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:01.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
